module.exports = __webpack_public_path__ + "static/media/bi_uniform_img_20251124.b7efbaf7.png";